export function getDaysBetweenDates(
  startDate: string,
  endDate: string | undefined | null
) {
  if (!startDate) return 0
  if (!endDate) return Infinity

  const start = new Date(startDate)
  const end = new Date(endDate)
  const diffTime = Math.abs(end.getTime() - start.getTime())
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1
}
